import * as types from './action-types'
import _ from 'lodash'

export const selectField = (field, dimension) => {
  return {
    type: types.SELECT_FIELD,
    field: field,
    dimension: dimension || 'x'
  };
};

export const selectSex = (sex) => {
  return {
    type: types.SELECT_SEX,
    sex
  };
};

export const selectAge = (age) => {
  return {
    type: types.SELECT_AGE,
    age
  };
};

export const selectRace = (race) => {
  return {
    type: types.SELECT_RACE,
    race
  };
};

export const selectDemographic = (demographic, value) => {
  switch (demographic) {
    default:
    case 'sex':
      return selectSex(value);
    case 'age':
      return selectAge(value);
    case 'race':
      return selectRace(value);
  }
};

export const resetDemographics = () => {
  return {
    type: types.RESET_DEMO
  };
};

export const getCountyProviders = (countyFips) => {
  return {
    type: types.GET_COUNTY_PROVIDERS,
    countyFips
  };
};

export const selectState = (stateFips, countyFips) => {
  return (dispatch, getState) => {

    countyFips = countyFips || _.find(getState().counties.rawData, ['sf', stateFips]).cf;

    dispatch({
      type: types.SELECT_STATE,
      stateFips
    });

    dispatch(selectCounty(countyFips));
  }
};

export const selectCounty = (countyFips) => {
  return (dispatch, getState, api) => {

    dispatch({
      type: types.SELECT_COUNTY,
      countyFips
    });

    const state = getState();

    dispatch({
      type: types.UPDATE_OVERDOSE_LOCATIONS,
      state: state.states.selected,
      county: state.counties.selected,
    });

    return api.getCountyProviders(countyFips)
      .then(data => dispatch({
        type: types.COUNTY_PROVIDERS_RECEIVED,
        data
      }));
  }
};

export const getCountyData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_COUNTY_DATA});

    return api.getCountyData()
      .then(data => dispatch({
        type: types.COUNTY_DATA_RECEIVED,
        data
      }));
  }
};

export const getStateData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_STATE_DATA});

    return api.getStateData()
      .then(data => dispatch({
        type: types.STATE_DATA_RECEIVED,
        data
      }));
  }
};

export const getDemographicsData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_DEMOGRAPHICS_DATA});

    return api.getDemographicsData()
      .then(data => dispatch({
        type: types.DEMOGRAPHICS_DATA_RECEIVED,
        data
      }));
  }
};

export const initializeData = () => {
  return dispatch => {

    const ohioFips = 39;
    const countyFip = 39035;

    return dispatch(getCountyData())
      .then(() => dispatch(getDemographicsData()))
      .then(() => dispatch(getStateData()))
      .then(() => dispatch(selectState(ohioFips, countyFip)));
  }
};


// WEBPACK FOOTER //
// ./src/actions/map-actions.js